<template>

  <div class="kw_relation_graph">
    <div style="height:calc(100vh - 50px);">
        <RelationGraph ref="seeksRelationGraph" :options="graphOptions" :on-node-click="onNodeClick" :on-line-click="onLineClick" />
     </div>
  </div>
</template>

<script>
import RelationGraph from 'relation-graph'
import pageUtils from '@/js/page/pageUtil.js'; 
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_relation_graph',
  props: {
    item: {
      type: Object,
      default: null
    },
    styleSet: {
      type: Object,
      default: null
    },
    imgSrc: {
      type: String,
      default: null
    },
    imgSrcArr: {
      type: Array,
      default: null
    },
    zdyClass:{
      type: String,
      value: 'RankingImg'
    },
    pageSetInfo:{
      type: Object,
      default: function(){
        return {};
      }
    },
    dataInfo:{
      type: Object,
      default: function(){
        return {};
      }
    },
    ifRefresh:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      graphOptions: {
         allowSwitchLineShape: true,
         allowSwitchJunctionPoint: true,
         defaultJunctionPoint: 'border'
         // 这里可以参考"Graph 图谱"中的参数进行设置
       }
    };
  },
  created() {
    
    
  },
  mounted() {
    this.refreshRelationGraph()
  },
  beforeDestroy(){
    
  },
  destroyed(){

  },
  watch:{
    ifRefresh:function(newVal){
      console.log("pageSetInfo==============watch================",this.pageSetInfo);
      this.refreshRelationGraph();
    }
  },
  computed:{
  },
  components: {
    RelationGraph
  },
  methods: {
    refreshRelationGraph(query) {
      var that = this;
      var pageSetInfo = this.pageSetInfo;
      var tabPageSet = pageSetInfo.tabPageSet;
      var __graph_json_data = {
        rootId: '',
        nodes: [
          // { id: 'a', text: 'A'},
          // { id: 'b', text: 'B'},
          // { id: 'c', text: 'C'},
          // { id: 'e', text: 'E'}
        ],
        links: [
          // { from: 'a', to: 'b', text: '关系1', color: '#43a2f1' },
          // { from: 'a', to: 'c', text: '关系2' },
          // { from: 'a', to: 'e', text: '关系3' },
          // { from: 'b', to: 'e', color: '#67C23A' }
        ]
      }
      if(tabPageSet){

        //第一个选项卡为实体 第二个选项卡为关系 第三个选项卡为属性
        if(tabPageSet.length >= 1) {
          var tabOne = tabPageSet[0];
          if(tabOne.pageDataInfo) {
              tabOne.pageDataInfo.forEach(function (markerOne,markerIndex) {
                __graph_json_data.nodes.push({
                  id:""+markerOne.ID,
                  text:markerOne.NAME
                });
                if(__graph_json_data.rootId == "") {
                  __graph_json_data.rootId = markerOne.ID;
                }
              })
          }
        }
        if(tabPageSet.length >= 2) {
          var tabOne = tabPageSet[1];
          if(tabOne.pageDataInfo) {
              tabOne.pageDataInfo.forEach(function (markerOne,markerIndex) {
                __graph_json_data.links.push({
                  from:""+markerOne.FROM_ID,
                  to:""+markerOne.TO_ID,
                  text:markerOne.NAME
                });
              })
          }
        }
        if(tabPageSet.length >= 3) {
          var tabOne = tabPageSet[2];
          if(tabOne.pageDataInfo) {
              tabOne.pageDataInfo.forEach(function (markerOne,markerIndex) {
                 __graph_json_data.nodes.push({
                  id:'ELE_'+markerOne.TO_ID,
                  text:markerOne.NAME
                });
                __graph_json_data.links.push({
                  from:""+markerOne.FROM_ID,
                  to:'ELE_'+markerOne.TO_ID,
                  text:markerOne.RELATION_NAME
                });
              })
          }
        }
      }
       
      // 以上数据中的node和link可以参考"Node节点"和"Link关系"中的参数进行配置 
      console.log("this.$refs.seeksRelationGraph====================",this.$refs.seeksRelationGraph);
      if(__graph_json_data.rootId != "") {
         this.$refs.seeksRelationGraph.setJsonData(__graph_json_data, (seeksRGGraph) => {
           // Called when the relation-graph is completed 
         })
      }
     },
     onNodeClick(nodeObject, $event) {
       console.log('onNodeClick:', nodeObject)
     },
     onLineClick(lineObject, $event) {
       console.log('onLineClick:', lineObject)
     }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
